import { ref } from 'vue'
import { defineStore } from 'pinia'
import { AudienceBuilder, GetStandaloneExploreSearchListQuery, StandaloneAudienceConfig, StandaloneExploreSearch } from '@/api'

const STORE_KEY = 'protargeting-saved-audiences'

export const useSavedAudiencesStore = defineStore(STORE_KEY, () => {
  const FRIENDLY_QUERY_TYPES = {
    handle_analysis: 'Handle Analysis',
    audience_analysis: 'Audience Analysis',
    conversation_analysis: 'Conversation Analysis',
    post_analysis: 'Post Analysis',
    audience_builder: 'Audience Builder',
  }

  const email = ref<GetStandaloneExploreSearchListQuery['email']>()
  const adAccountId = ref<GetStandaloneExploreSearchListQuery['ad_account_id']>()
  const queryType = ref<GetStandaloneExploreSearchListQuery['query_type'] | 'all'>('all')

  const audience = ref<StandaloneExploreSearch>()
  const audienceBuilder = ref<AudienceBuilder>()
  const config = ref<StandaloneAudienceConfig>()

  const loading = ref(false)
  const audiences = ref<StandaloneExploreSearch[]>()
  const loadingBuilder = ref(false)
  const audiencesBuilder = ref<AudienceBuilder[]>()

  const isOpenUploadAudience = ref(false)
  const isOpenUploadAudienceBuilder = ref(false)

  return {
    FRIENDLY_QUERY_TYPES,
    email,
    adAccountId,
    queryType,
    loading,
    config,
    audience,
    audiences,
    loadingBuilder,
    audiencesBuilder,
    audienceBuilder,
    isOpenUploadAudience,
    isOpenUploadAudienceBuilder,
  }
})
